import React from 'react';
import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import TickedSlider from '../../../../../../../../../agencies/quotes/PrimeX/customizeQuote/components/TickedSlider';
import useTypingTimeout from '../../../../hooks/useTypingTimeout';
import CoverageOptionsLabel from '../../../../../../../../primeX-underwriter/components/amendatoryCoverages/components/shared/CoverageOptionsLabel';

const AmendCooperation = (props: AmendatoryLineItemProps) => {
  const _sliderTo = props.rules?.percentage?.to;
  const _sliderFrom = props.rules?.percentage?.from;

  const handleChange = useTypingTimeout((newValue: number | number[]) => {
    props.setCoverage({
      id: props.id,
      value: { props: { percentage: { value: newValue as number } } },
    });
  });

  return (
    <CoverageOptionsWrapper>
      <CoverageOptionsLabel htmlFor="amendCooperationPercentage">
        Amend Cooperation % of Liability Expenses
      </CoverageOptionsLabel>
      <TickedSlider
        boxProps={{
          alignItems: 'center',
          gap: '1rem',
          width: '14rem',
        }}
        name="amendCooperationPercentage"
        onChange={handleChange.onChange}
        disabled={!props.isSelected}
        min={Number(_sliderFrom)}
        initialSliderValue={props.value?.props.percentage?.value as number}
        max={Number(_sliderTo)}
        step={props.rules?.percentage?.step}
      >
        {(value) => <>{value}%</>}
      </TickedSlider>
    </CoverageOptionsWrapper>
  );
};

export default AmendCooperation;
